<template>
    <div class="quotation-calculator-main">
        <div class="quotation-calculator-anchor" id="scroll-anchor"></div>
        <StagedForm :stages="stages">            <template #stage-customer-type>
                <StageCustomerType />
            </template>            <template #stage-products>
                <StageProducts :cartItems="cartItems" />
            </template>
            <template #stage-details>
                <StageDetails :cartItems="cartItems" />
            </template>
            <template #stage-quotation>
                <StageQuotation :cartItems="cartItems" />
            </template>
        </StagedForm>
        <div class="disclaimers-section">
            <div class="disclaimers-title">Disclaimers</div>
            <ul class="disclaimers">
                <li class="disclaimer"><span>1</span>Please note that our quick quote is a rough estimate. To get an accurate estimate please get in touch with our office.</li>
                <li class="disclaimer"><span>2</span><p style="width:100%">Only Interlock is available in 50mm, 60mm and 80mm. If options are not available, please refresh page. Colours marked *
                are not standard stock colours and require a minimum order quantity. Quotes and orders of kerbs are sold in linear
                meters, but also available in 330mm shorts.</p></li>
                <li class="disclaimer"><span>3</span>This cost calculator provides a rough cost estimate and delivery costs are rounded up to the nearest distance and maximum quantity per load.</li>
                <li class="disclaimer"><span>4</span>This estimate is valid for 30 days.</li>
                <li class="disclaimer"><span>5</span>All products ordered for delivery are sold per pack sizes. Loose products can be collected from our premises.</li>
                <li class="disclaimer">
                    <span>6</span>For orders with deliveries farther than 250km, kindly contact our office for an accurate estimate -&nbsp;
                    <a href="mailto:sales@mvabricks.co.za" target="_blank" rel="nofollow">sales@mvabricks.co.za</a>&nbsp;|&nbsp;<a href="tel:0123860050" target="_blank" rel="nofollow"
                        >(012) 386 0050</a
                    >
                </li>
            </ul>
        </div>
        <notifications group="main" position="bottom center" :duration="5000" width="380px" classes="vue-notification notification-top" />
    </div>
</template>

<script setup>
import { ref } from "vue";
import { useHead } from "@vueuse/head";

import StagedForm from "@/components/staged-form.component.vue";
import StageCustomerType from "@/components/stage-customer-type.component.vue";
import StageProducts from "@/components/stage-products.component.vue";
import StageDetails from "@/components/stage-details.component.vue";
import StageQuotation from "@/components/stage-quotation.component.vue";

const stages = ref([
	{
		id: "stage-customer-type",
		title: "Get Started",
		stageSelectorTitle: "Customer Type",
	},
	{
		id: "stage-products",
		title: "Add Products to Quotation",
		stageSelectorTitle: "Choose Products",
	},
	{
		id: "stage-details",
		title: "Your Details",
		stageSelectorTitle: "Your Details",
	},
	{
		id: "stage-quotation",
		title: "Your Quotation",
		stageSelectorTitle: "Your Quotation",
	},
]);

const cartItems = ref([]);

// Load Google reCAPTCHA
useHead({
	script: [
		{
			src: "https://www.google.com/recaptcha/api.js?render=6LeAiC0hAAAAANWECg_C_6NSCf7vnxUhQ6a9U6-E",
			async: true,
			defer: true,
		},
	],
});
</script>

<style lang="scss">
@import '@/scss/index.scss';

// Remove in production build
.quotation-calculator-main {
    max-width: 1120px;
    // border: 1px solid #efefef;
    margin: 0 auto;
}

.disclaimers-section {
    .disclaimers-title {
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0.5px;
        position: relative;
        padding-bottom: 6px;
        margin-bottom: 10px;
        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 40px;
            height: 2px;
            background-color: $cl-primary;
        }
    }
    .disclaimers {
        list-style-type: none;
        margin: 0;
        padding: 0;
        .disclaimer {
            font-size: 16px;
            display: flex;

            &:not(:last-child) {
                margin-bottom: 8px;
            }
            span {
                font-size: 12px;
                display: flex;
                width: 20px;
                height: 20px;
                background-color: $cl-primary;
                border-radius: 50%;
                color: white;
                font-weight: bold;
                justify-content: center;
                align-items: center;
                margin-top: 2px;
                margin-right: 8px;
            }
            a {
                color: $cl-primary;
                text-decoration: none;
                opacity: 1;
                transition: opacity 150ms ease-out;
                &:hover {
                    opacity: 0.75;
                }
            }

            @media only screen and (max-width: 768px) {
                display: block;
                span {
                    display: inline-flex;
                }
            }
        }
    }
}
</style>
